const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgConversation(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 425.197 425.197",
    style: {
      enableBackground: "new 0 0 425.197 425.197"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    y: 0,
    style: {
      fill: "#FFFFFF"
    },
    width: 425.197,
    height: 425.197
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#EDE9D8"
    },
    d: "M82.439,386.502h146.06c34.016-23.307,56.335-62.437,56.335-106.784 c0-71.446-57.919-129.364-129.364-129.364c-71.446,0-129.364,57.918-129.364,129.364C26.105,324.065,48.425,363.195,82.439,386.502 z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#EDE9D8"
    },
    d: "M197.741,386.502h146.06c34.016-23.307,56.335-62.437,56.335-106.784 c0-71.446-57.919-129.364-129.364-129.364c-71.446,0-129.364,57.918-129.364,129.364 C141.407,324.065,163.727,363.195,197.741,386.502z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#EDE9D8"
    },
    d: "M168.51,221.921h121.469c28.288-19.384,46.85-51.925,46.85-88.806 c0-59.417-48.167-107.584-107.584-107.584c-59.418,0-107.584,48.167-107.584,107.584 C121.66,169.996,140.221,202.537,168.51,221.921z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#E3E3E3"
    },
    d: "M26.105,386.263c0,4.397,23.857,7.958,53.287,7.958c29.434,0,53.288-3.562,53.288-7.958 c0-4.397-23.854-7.961-53.288-7.961C49.962,378.302,26.105,381.865,26.105,386.263z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#E3E3E3"
    },
    d: "M249.303,386.263c0,4.397,33.764,7.958,75.412,7.958c41.655,0,75.421-3.562,75.421-7.958 c0-4.397-33.766-7.961-75.421-7.961C283.066,378.302,249.303,381.865,249.303,386.263z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#007987"
    },
    d: "M283.826,58.097L174.663,72.033c-11.546,0-20.904,9.359-20.904,20.903v41.81 c0,11.543,9.358,20.902,20.904,20.902h7.701l-2.567,20.529l29.238-20.529h74.791c11.546,0,20.903-9.359,20.903-20.902V79.001 C304.729,67.456,295.372,58.097,283.826,58.097z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#DDA076"
    },
    d: "M307.111,245.632c0,0-36.52,31.631-46.364,39.134c-4.11,3.131-51.033,24.728-51.033,24.728 s-3.738,0.115-6.092,0.559c-1.618,0.302-7.946,1.381-9.89,2.114c-1.944,0.727-1.164,6.939,0.958,7.721 c2.1,0.774,9.18,0.261,9.18,0.261s4.686,0.776,5.942-0.251c1.882-1.531,3.13-4.009,3.13-4.009s42.513-13.673,56.101-21.877 c13.076-7.892,45.967-33.069,45.967-33.069L307.111,245.632z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#007D84"
    },
    d: "M296.934,276.565l16.169-20.854c0,0,16.228-19.277-0.695-16.892 c-9.316,1.312-25.009,22.124-25.009,22.124L296.934,276.565z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#0D0E22"
    },
    d: "M352.506,385.21c1.052-5.575,1.355-11.228,0.571-16.964c-12.311-0.67-51.674-0.242-51.674-0.242 l-2.23,17.207H352.506z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#1D2342"
    },
    d: "M356.549,385.21c0.079-5.81-0.339-11.695-1.484-17.656c-12.333,0-55.487,2.21-55.487,2.21 l2.316,15.446H356.549z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#0BA4A1"
    },
    d: "M354.666,367.554l-55.486,2.21c0,0,0.228-88.516,2.77-106.049 c2.405-16.597,10.458-24.896,10.458-24.896l15.403-2.076c0,0,15.051,6.092,20.463,31.885 c3.142,14.969,2.751,45.883,3.584,69.196C352.457,354.678,354.666,367.554,354.666,367.554z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F9BB8D"
    },
    d: "M312.407,238.819l15.403-2.076l-0.468-4.875c0,0,8.626-5.126,12.019-11.858 c3.676-7.294,6.038-21.915,7.449-30.713c1.778-11.079-8.757-21.85-8.757-21.85l-27.996,0.742c0,0-4.7,2.089-6.193,11.568 c-0.921,5.837,1.634,14.929,1.634,14.929s-1.817,6.183-6.113,10.8c-1.397,1.499,2.933,3.375,2.933,3.375 s0.449,12.676,2.09,16.395c1.643,3.722,8.001,7.383,8.001,7.383L312.407,238.819z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#0D0E22"
    },
    d: "M302.338,208.934c0,0.259,0.086,2.062,0.214,4.426c0.088,1.116,0.174,2.362,0.302,3.608 c0.342,3.264,0.858,6.658,1.547,8.292c1.634,3.735,7.99,7.389,7.99,7.389s14.648-4.381,17.615-8.164 c2.919-3.737,3.135-20.318,3.135-20.318s-3.353-5.157-4.427-1.033c-1.028,4.126,1.546,13.405-3.607,17.702 c-2.234,1.847-6.314-9.15-13.361-11.127C305.817,208.077,302.338,208.934,302.338,208.934z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F9BB8D"
    },
    d: "M302.552,213.36c0.088,1.116,0.174,2.362,0.302,3.608l1.116-0.259c0,0,2.233,5.373,6.271,5.931 c2.534,0.343,4.812-0.645,4.769-3.396C314.923,213.402,304.227,213.315,302.552,213.36z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#0D0E22"
    },
    d: "M339.226,153.23c6.408,2.534,6.071,7.272,6.071,7.272s3.125,1.097,6.946,4.396 c5.221,4.509,1.969,23.55-0.86,40.714c-3.492,21.205-16.565,20.383-16.565,20.383l-1.183-13.583c0,0,2.265,1.075,5.086-1.61 c1.381-1.315,4.391-10.447,1.156-11.007c-7.735-1.345-5.899,8.051-9.341,6.679c-3.441-1.372-1.61-2.778-0.276-9.632 c2.686-12.352-2.281-14.903-2.281-14.903s-14.327,0.948-22.679-1.629c-8.512-2.624-12.203-17.598-2.962-19.987 C312.717,157.64,332.824,150.69,339.226,153.23z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#008D90"
    },
    d: "M325.089,259.219c0,0,12.381,30.545,16.726,30.167c10.27-0.893,12.851-11.263,12.851-11.263 c-10.401-6.751-12.497-15.253-19.175-18.783C328.235,268.3,325.089,259.219,325.089,259.219z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F9BB8D"
    },
    d: "M338.977,275.834c7.78,11.819,14.002,27.531,14.791,36.107 c0.786,8.576-17.196,42.807-17.196,42.804c0,0-4.743,1.514-5.934,3.592c-0.816,1.43-0.691,6.204,0.534,7.594 c1.375,1.558,8.216,1.126,8.942,0.82c2.064-0.869,0.572-3.921,0.572-3.921s3.76-1.151,3.793-2.772 c0.054-2.425-0.944-3.626-0.944-3.626s25.391-35.927,24.043-46.791c-1.351-10.864-6.5-27.918-11.735-38.599 C349.121,257.434,329.44,263.729,338.977,275.834z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#0BA4A1"
    },
    d: "M360.67,274.362c0,0-13.206-21.414-21.641-29.446c-8.621-8.216-22.202-0.661-13.94,14.302 c7.975,14.449,16.726,26.947,16.726,26.947L360.67,274.362z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F9BB8D"
    },
    d: "M112.795,244.794c0,0,25.863,25.463,34.53,23.601c31.427-6.748,46.354-27.971,46.354-27.969 c0,0,1.615-3.371,2.967-5.345c0.932-1.361,4.467-6.717,5.925-8.201c1.451-1.488,6.814,1.73,6.681,3.991 c-0.138,2.233-3.466,8.504-3.466,8.504s-1.178,4.601-2.626,5.338c-2.158,1.104-4.927,1.248-4.927,1.248 s-22.806,21.944-48.948,33.543c-7.201,3.196-32.02-11.763-32.02-11.763L112.795,244.794z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#12142B"
    },
    d: "M195.655,248.432c0,0-25.947,25.846-48.004,32.871c-14.078,4.485-35.695-25.965-35.695-25.965 s-13.448-14.642,1.558-15.204c6.689-0.251,25.844,24.979,32.504,26.002c12.568,1.934,45.871-23.548,45.871-23.548 L195.655,248.432z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#12142B"
    },
    d: "M118.818,346.414c6.575-23.8,11.472-51.552,9.228-77.363 c-2.183-25.111-17.083-30.229-17.083-30.229l-10.552,2.858c0,0-11.998,10.99-7.968,37.034 c1.08,6.971,5.192,43.074,5.192,43.074S109.295,380.876,118.818,346.414z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#1F191E"
    },
    d: "M119.422,385.21l4.368-14.266c0,0-37.185-12.919-49.072-16.196 c-4.793,9.69-6.499,19.98-6.63,30.461H119.422z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#352E35"
    },
    d: "M123.481,385.21l0.707-15.443c0,0-43.155-2.211-55.485-2.211 c-1.146,5.961-1.283,11.844-0.733,17.654H123.481z"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F0F0F0"
    },
    d: "M68.703,367.556l55.485,2.211c0,0-0.227-88.518-2.771-106.051 c-2.407-16.594-10.455-24.894-10.455-24.894l-15.354-2.037c0,0-15.103,6.053-20.514,31.843 C71.952,283.599,68.703,367.556,68.703,367.556z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#1D2342"
    },
    d: "M40.654,385.21c16.597-11.768,56.963-44.491,70.451-92.546 c6.811-24.268-2.992-53.842-2.992-53.842l-12.504-2.037c0,0-15.103,6.053-20.514,31.843 c-1.451,6.904-10.332,42.139-10.332,42.139s-24.972,26.649-31.126,38.874c-4.377,8.691-2.368,26.866-1.058,35.569H40.654z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F9BB8D"
    },
    d: "M110.963,238.822l-15.354-2.037l0.572-5.292c0,0-8.066-5.966-10.768-13.005 c-2.923-7.629-3.804-22.41-4.325-31.308c-0.658-11.199,6.612-20.859,6.612-20.859l32.076,3.552c0,0,3.959,4.679,3.771,14.275 c-0.188,9.596-2.426,4.232-2.17,11.357c0.252,7.126,5.028,10.509,5.272,12.547c0.242,2.035-3.262,3.066-3.262,3.066 s0.148,15.098-3.358,19.078c-3.506,3.979-9.067,3.563-9.067,3.563V238.822z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#1A1418"
    },
    d: "M87.961,152.057c-6.627,1.879-5.672,8.28-5.672,8.28s-4.319-0.875-8.449,2.023 c-5.648,3.961-7.271,25.579-2.763,40.938c7.464,25.454,17.354,20.998,17.354,20.998l3.646-11.833c0,0-4.541,2.885-6.915-3.732 c-2.376-6.618-3.394-13.577,2.033-14.086c5.434-0.509,5.773,9.504,9.335,8.484c3.563-1.017-3.812-6.617-4.453-13.576 c-0.295-20.019,8.711-12.558,8.711-12.558s13.805,6.246,22.506,5.415c8.699-0.832,8.797-16.503,1.066-23.738 C116.625,151.436,94.589,150.176,87.961,152.057z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F9BB8D"
    },
    d: "M115.583,270.796c26.504,42.759,73.087,40.658,73.087,40.658s3.633-0.886,6.018-1.092 c1.642-0.142,8.026-0.802,10.097-0.616c2.07,0.18,2.982,6.37,1.146,7.698c-1.813,1.309-8.773,2.71-8.773,2.71 s-4.305,2.005-5.793,1.352c-2.222-0.972-4.086-3.022-4.086-3.022s-53.019,4.169-80.515-29.732 C97.241,276.934,108.606,257.057,115.583,270.796z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#A6C1D1"
    },
    d: "M107.607,303.276c0,0-9.782-10.429-17.792-37.14c-2.962-9.877,16.22-18.875,16.22-18.875 s7.479,6.757,5.346,18.875C116.063,282.711,107.607,303.276,107.607,303.276z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#1D2342"
    },
    d: "M187.277,318.484c0,0-67.4,11.669-97.52-54.923c-4.906-10.85,10.4-28.283,16.586-12.348 c21.725,55.981,79.521,60.226,79.521,60.226L187.277,318.484z"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgConversation);
export default __webpack_public_path__ + "static/media/conversation.09bc0b62f71d3af310b2b5c1b8ceb6dd.svg";
export { ForwardRef as ReactComponent };